import React, { useState } from 'react';
import TierPopup from '@wix/da-shared-react/pkg/Tier/TierPopup';
import TempAssoc from './TempAssoc';

export interface Props {}

const SubscriptionsSection: React.FC<Props> = props => {
  const [selectedDev, setSelectedDev] = useState<any>();
  return (
    <>
      <TempAssoc onSelect={d => setSelectedDev(d)} />
      <TierPopup
        key={selectedDev ? selectedDev?.deviationId : undefined}
        deviation={selectedDev}
        requestClose={() => null}
      />
    </>
  );
};
SubscriptionsSection.displayName = 'SubscriptionsSection';

export default SubscriptionsSection;
